export default "__VITE_ASSET__89dfcc35__"